import React, { useRef, useState, useEffect } from "react";
import "../../../../StyleSheet/MainComponent/UDSEMployee/Navbar.scss";
import profile2 from "../../../../Assets/AppComponent/Profile/profile2.png";
import $ from "jquery";

import { useDispatch, useSelector } from "react-redux";
import {
  getsidebarActions,
  getSideBarfilesActions,
} from "../../../../Redux/Slice";
import ReorderOutlinedIcon from "@material-ui/icons/ReorderOutlined";
import Logo1 from "../../../../Assets/AppComponent/Logo/Group 85.png";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { Link, useNavigate } from "react-router-dom";
import shortLogo from "../../../../Assets/MainComponent/Group 84.svg";

import logoimg from "../../../../Assets/AppComponent/Qpms/qmp-logo.png";

const UDSNavbar = () => {
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const [LogoOut, setLogoOut] = useState(false);
  const stateToggle = useSelector((state) => state.SideBarActive.SidebarActive);
  const UserData = useSelector(
    (state) => state.CustomUDSEMployeeLogin.CustomoginDATAs != undefined && state.CustomUDSEMployeeLogin.CustomoginDATAs.data != undefined && state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data != undefined ? state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data : []
  );
  const state = useSelector((state) => state)
  const [isActive, setActive] = useState(false);
  const [dropStatus, setDropStatus] = useState(false);
  const navigate = useNavigate();
  const stateToogle = useSelector((state) => state.SideBarActive.SidebarActive);
  const [userimages, setusermages] = useState(state.SideBarFiles.UDSEmployeeeImage)


  const HandleSideToggle = () => {
    dispatch(getsidebarActions(!stateToggle));
  };
  useEffect(() => {
    setActive(stateToggle);
  }, [stateToggle]);
  const handleLogout = () => {
    window.location.reload();
    localStorage.clear();
    window.location.href = "/customudsemployee";
  };

  useEffect(() => {
    setusermages(state.SideBarFiles.UDSEmployeeeImage)
  }, [state.SideBarFiles.UDSEmployeeeImage])
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setDropStatus(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const HandleClick = () => {
    $(".dropdown-menu").toggle();
    setLogoOut(!LogoOut);
  };
  $(".App").on("click", function () {
    $(".dropdown-menu").hide();
  });
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };


  return (
    <>
      <div class="header">
        <div className={stateToogle ? "HeaderPart" : "header-left"}>
          <a
            onClick={(e) => {
              // dispatch(getSideBarfilesActions("DashBoard"));
              // navigate("/");
            }}
            class="logo NormalLogo"
          >
            <img src={logoimg} alt="Logo" />
          </a>
          {/* <a
            onClick={(e) => {
            }}
            class=" logo-small"
          >
            <img src={logoimg} alt="Logo" width="40" height="70" />
          </a> */}
        </div>
        <div
          className={` NavbarClicks ${stateToogle ? "toggelTes" : "toggle"}`}
          onClick={HandleSideToggle}
        >
          <a
            href="javascript:void(0);"
            className={` ICONS ${stateToogle ? "closetoggle" : "toggle_btn"}`}
          >
            <MenuRoundedIcon
              style={{
                width: "40px",
                height: "30px",
                cursor: "pointer",
                color:"#234492"

              }}
            />

            {/* <i class="fa-solid fa-bars toggleBtns" ></i> */}
          </a>
        </div>
        <ul class="nav user-menu">
          <div className="NavMenuSet">
            <div className="NavMenus">
              <div className="User-Menu">
                <div className="Profile-Name">
                  <div
                    className="AdminImg"
                    onClick={(e) => {
                      HandleClick();
                    }}
                    style={{ border: "1px solid #ddd" }}
                  >
                    <img
                      src={userimages || profile2}
                    />
                  </div>
                  {/* <span>{UserData.first_name}</span> */}
                </div>

                <div className={`dropdown-menu `}>
                  <div class="user-header">
                    <div
                      class="avatar avatar-sm"
                      // style={{ width: "70px", height: "70px" }}
                      style={{ width: "77px", height: "67px", border: "1px solid #ddd", borderRadius: "50%" }}
                    >
                      <img
                        src={userimages || profile2}
                        alt="User Image"
                        class="avatar-img rounded-circle"
                        style={{ width: "100%", dropdownheight: "100%", height: "100%" }}
                      />
                    </div>
                    <div class="user-text">
                      <div className="row">
                        <div className="col-md-6" style={{ textAlign: "end" }}>
                          <h6>User :</h6>
                        </div>
                        <div
                          className="col-md-6"
                          style={{ textAlign: "center" }}
                        >
                          {UserData != undefined &&
                            UserData.first_name != undefined ? (
                            <p class="text-muted lead mb-0">
                              {UserData.first_name}
                            </p>
                          ) : null}
                        </div>
                        <div className="col-md-6" style={{ textAlign: "end" }}>
                          <h6>Role :</h6>
                        </div>
                        <div
                          className="col-md-6"
                          style={{ textAlign: "center" }}
                        >
                          {UserData.user_role.role != undefined ? (
                            <p class="text-muted lead mb-0">
                              {capitalizeFirstLetter(UserData.user_role.role)}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <a class="dropdown-item" href="#">My Profile</a>
                                  <a class="dropdown-item" href="#">Settings</a> */}
                  <div className="BtnPart">
                    <button
                      class="dropdown-item ButtonCSS"
                      href="#"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                    <button
                      class="dropdown-item ButtonCSS"
                      style={{ marginLeft: "12px", display: "flex", justifyContent: "center", textAlign: "center" }}
                      href="#"
                      onClick={(e) => {
                        navigate("/emp_profile")
                      }}
                    >
                      Profile
                    </button>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </>


  );
};

export default UDSNavbar;
